'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _freeRegularSvgIcons = require('@fortawesome/free-regular-svg-icons');
var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var IconWrapper = _styledComponents2['default'].span.withConfig({
  displayName: 'CheckBoxBase__IconWrapper',
  componentId: 'sc-1zqmg5-0'
})(_templateObject, function (props) {
  var disabled = props.disabled,
    checked = props.checked,
    checkbox = props.theme.checkbox;
  if (disabled) {
    return checkbox.disabled;
  }
  if (checked) {
    return checkbox.checked;
  } else {
    return checkbox.unchecked;
  }
});

/**
 * Checkbox component. This component is a controlled component, meaning it does not
 * store whether it is checked or not as internal state. You must control the component
 * state through the API by using the checked and changeHandler properties.
 */

var CheckBoxBase = function (_Component) {
  _inherits(CheckBoxBase, _Component);
  function CheckBoxBase(props) {
    _classCallCheck(this, CheckBoxBase);
    var _this = _possibleConstructorReturn(this, (CheckBoxBase.__proto__ || Object.getPrototypeOf(CheckBoxBase)).call(this, props));
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  _createClass(CheckBoxBase, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          labelPosition = _props.labelPosition,
          name = _props.name;
        return _react2['default'].createElement('span', {
          className: className + ' checkbox',
          onClick: !disabled ? this.handleClick : null,
          name: name
        }, _react2['default'].createElement('label', null, labelPosition === 'left' ? this.renderLabel(labelPosition) : null, this.renderIcon(), labelPosition === 'right' ? this.renderLabel(labelPosition) : null));
      }
      return render;
    }()
  }, {
    key: 'renderLabel',
    value: function () {
      function renderLabel(labelPosition) {
        var label = this.props.label;
        return label && label.length > 0 ? _react2['default'].createElement('span', {
          className: 'checkbox-label checkbox-label-' + labelPosition
        }, label) : null;
      }
      return renderLabel;
    }()
  }, {
    key: 'renderIcon',
    value: function () {
      function renderIcon() {
        var _props2 = this.props,
          checked = _props2.checked,
          disabled = _props2.disabled,
          value = _props2.value;
        var icon = null;
        if (checked) {
          icon = _freeSolidSvgIcons.faCheckSquare;
        } else {
          if (disabled) {
            icon = _freeSolidSvgIcons.faSquare;
          } else {
            icon = _freeRegularSvgIcons.faSquare;
          }
        }
        return _react2['default'].createElement(IconWrapper, {
          disabled: disabled,
          checked: checked
        }, _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: icon,
          value: value
        }));
      }
      return renderIcon;
    }()
  }, {
    key: 'handleClick',
    value: function () {
      function handleClick(evt) {
        this.props.changeHandler(!this.props.checked, this.props.value, evt);
      }
      return handleClick;
    }()
  }]);
  return CheckBoxBase;
}(_react.Component);
CheckBoxBase.defaultProps = {
  changeHandler: function () {
    function changeHandler() {}
    return changeHandler;
  }(),
  checked: false,
  disabled: false,
  name: 'checkbox',
  label: '',
  labelPosition: 'right',
  value: null
};
CheckBoxBase.propTypes = {
  /**
   * Function called when a checkbox is clicked.
   * @param {boolean} checked true if the checkbox is checked, otherwise false.
   * @param {string} value The value of the checkbox.
   * @param {object} evt The event object.
   */
  changeHandler: _propTypes2['default'].func,
  /**
   * Allows for controlled component. Used to display when checkbox is checked.
   */
  checked: _propTypes2['default'].bool,
  /**
   * Property to enable or disable the checkbox.
   */
  disabled: _propTypes2['default'].bool,
  /**
   * Name property to provide to the checkbox.
   */
  name: _propTypes2['default'].string,
  /**
   * Label to display next to the checkbox.
   */
  label: _propTypes2['default'].string,
  /**
   * Property to position the label either to the left or the right of the checkbox.
   */
  labelPosition: _propTypes2['default'].oneOf(['left', 'right']),
  /**
   * The value to associate with the checkbox.
   */
  value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
};
CheckBoxBase.displayName = 'CheckBox';
exports['default'] = CheckBoxBase;